import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <div className="flex items-center">
                {/* Triolift Logo */}
                <img 
                  src="/logo-colored.png" 
                  alt="Trolift Logo" 
                  className="h-16 w-auto"
                />
              </div>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-catalina-blue hover:text-tango transition duration-300 font-medium">
              Home
            </Link>
            <Link to="/about" className="text-catalina-blue hover:text-tango transition duration-300 font-medium">
              About
            </Link>
            <Link to="/solutions-we-provide" className="text-catalina-blue hover:text-tango transition duration-300 font-medium">
              Solutions We Provide
            </Link>
            <Link to="/products" className="text-catalina-blue hover:text-tango transition duration-300 font-medium">
              Products
            </Link>
            <Link to="/blog" className="text-catalina-blue hover:text-tango transition duration-300 font-medium">
              Blog
            </Link>
            <Link to="/contact" className="bg-tango text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition duration-300 font-medium">
              Contact
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-catalina-blue hover:text-tango focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className="block px-3 py-2 text-catalina-blue hover:bg-gray-100 rounded-md transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block px-3 py-2 text-catalina-blue hover:bg-gray-100 rounded-md transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <Link
              to="/solutions-we-provide"
              className="block px-3 py-2 text-catalina-blue hover:bg-gray-100 rounded-md transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Solutions We Provide
            </Link>
            <Link
              to="/products"
              className="block px-3 py-2 text-catalina-blue hover:bg-gray-100 rounded-md transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Products
            </Link>
            <Link
              to="/blog"
              className="block px-3 py-2 text-catalina-blue hover:bg-gray-100 rounded-md transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="block px-3 py-2 bg-tango text-white rounded-md hover:bg-orange-600 transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;